import { ReactNode } from 'react'

export interface NoOrphanProps {
	children: string
	as?: 'span' | 'div' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'
	className?: string
}

/**
 * Prevents text orphans by replacing the last space with a non-breaking space.
 * This ensures at least two words stay together on the last line.
 *
 * @example
 * <NoOrphan>This is a long text that might have an orphan</NoOrphan>
 */
export const NoOrphan = ({ children, as: Component = 'span', className }: NoOrphanProps): ReactNode => {
	const text = children.trim()
	const lastSpaceIndex = text.lastIndexOf(' ')

	if (lastSpaceIndex === -1) {
		// No spaces found, return as is
		return <Component className={className}>{text}</Component>
	}

	const beforeLastSpace = text.slice(0, lastSpaceIndex)
	const afterLastSpace = text.slice(lastSpaceIndex + 1)

	return (
		<Component className={className}>
			{beforeLastSpace}
			{'\u00A0'}
			{afterLastSpace}
		</Component>
	)
}
